import { put } from 'redux-saga/effects';
import { formControlActions } from 'store/formControlSlice/formControlSlice';

// Split view never renders the section indicator, so inventory validations requested there are
// skipped and replayed once the agent is back in the tab view.
const skippedFormIds = new Set();

export const markInventoryValidationSkipped = (formId, forms) => {
    for (const skippedFormId of skippedFormIds) {
        if (!forms?.[skippedFormId]) skippedFormIds.delete(skippedFormId);
    }
    skippedFormIds.add(formId);
};

export function* replayInventoryValidationsSkippedInSplitView() {
    const formIds = [...skippedFormIds];
    skippedFormIds.clear();
    for (const formId of formIds) {
        yield put(formControlActions.validateTransactionWithInventoryData({ formId }));
    }
}
